import NewsInsightsSearchResultsSummary from './NewsInsightsSearchResultsSummary';

export { type NewsInsightsSearchResultsSummaryProps } from './NewsInsightsSearchResultsSummary';
export default NewsInsightsSearchResultsSummary;
